import React, { useState, useEffect } from 'react';
import { Trash2, Mail } from 'lucide-react';

export default function ConfirmModal({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmText = 'Evet, Sil',
  cancelText = 'İptal',
  type = 'danger',
  requireText = false
}) {
  const [confirmationText, setConfirmationText] = useState('');

  useEffect(() => {
    if (isOpen) {
      setConfirmationText('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const colors = {
    danger: {
      bg: 'rgba(239,68,68,0.1)',
      icon: '#ef4444',
      btn: '#ef4444',
      shadow: 'rgba(239,68,68,0.3)'
    },
    warning: {
      bg: 'rgba(245,158,11,0.1)',
      icon: '#f59e0b',
      btn: '#f59e0b',
      shadow: 'rgba(245,158,11,0.3)'
    },
    info: {
      bg: 'rgba(0,122,255,0.1)',
      icon: '#007aff',
      btn: '#007aff',
      shadow: 'rgba(0,122,255,0.3)'
    }
  };

  const c = colors[type] || colors.danger;
  const Icon = type === 'warning' ? Mail : Trash2;

  const canConfirm = !requireText || confirmationText.trim().toUpperCase() === 'EVET';

  const handleConfirm = () => {
    if (!canConfirm) return;
    onConfirm();
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: 20
      }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div
        style={{
          background: 'white',
          borderRadius: 20,
          padding: '32px 28px',
          maxWidth: 380,
          width: '100%',
          boxShadow: '0 32px 80px rgba(0,0,0,0.2)',
          textAlign: 'center'
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: c.bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px'
          }}
        >
          <Icon size={24} color={c.icon} />
        </div>

        <div
          style={{
            fontWeight: 800,
            fontSize: 18,
            color: '#1a1a2e',
            marginBottom: 10
          }}
        >
          {title}
        </div>

        <div
          style={{
            fontSize: 14,
            color: '#6b7280',
            marginBottom: requireText ? 18 : 28,
            lineHeight: 1.6
          }}
        >
          {message}
        </div>

        {requireText && (
          <div style={{ marginBottom: 22, textAlign: 'left' }}>
            <label
              style={{
                display: 'block',
                fontSize: 12,
                fontWeight: 700,
                color: '#6b7280',
                marginBottom: 7
              }}
            >
              ONAYLAMAK İÇİN <span style={{ color: c.btn }}>EVET</span> YAZIN
            </label>

            <input
              autoFocus
              type="text"
              value={confirmationText}
              onChange={(e) => setConfirmationText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && canConfirm) {
                  handleConfirm();
                }
              }}
              placeholder="EVET"
              style={{
                width: '100%',
                boxSizing: 'border-box',
                padding: '12px 14px',
                border: `1.5px solid ${
                  confirmationText && !canConfirm
                    ? '#ef4444'
                    : confirmationText === 'EVET'
                    ? '#34c759'
                    : '#e5e7eb'
                }`,
                borderRadius: 10,
                outline: 'none',
                fontSize: 14,
                textAlign: 'center',
                fontWeight: 700,
                letterSpacing: 1,
                color: '#1a1a2e'
              }}
            />

            {confirmationText && !canConfirm && (
              <div
                style={{
                  fontSize: 11,
                  color: '#ef4444',
                  marginTop: 6
                }}
              >
                Lütfen tam olarak EVET yazın.
              </div>
            )}
          </div>
        )}

        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              padding: '12px',
              border: '1.5px solid #e5e7eb',
              borderRadius: 50,
              background: 'white',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: 14,
              color: '#6b7280'
            }}
          >
            {cancelText}
          </button>

          <button
            onClick={handleConfirm}
            disabled={!canConfirm}
            style={{
              flex: 1,
              padding: '12px',
              border: 'none',
              borderRadius: 50,
              background: canConfirm ? c.btn : '#d1d5db',
              color: 'white',
              cursor: canConfirm ? 'pointer' : 'not-allowed',
              fontWeight: 700,
              fontSize: 14,
              boxShadow: canConfirm
                ? `0 4px 14px ${c.shadow}`
                : 'none',
              transition: 'all 0.2s ease'
            }}
          >
            {requireText ? 'Eğitimi Sil' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
